import { MessagesPage } from './pages';
import { AutomationsPage } from 'pages/Common/Automations/AutomationsPage';

import paths from './paths';

const routes = {
  profile: {
    label: (t) => t('Profile'),
    component: null,
    exact: true,
    icon: 'id-card',
    invalidateTimeline: false,
  },
  messages: {
    label: (t) => t('Messages'),
    component: MessagesPage,
    exact: true,
    icon: 'envelope',
    invalidateTimeline: true,
  },
  automations: {
    label: (t) => t('Agentic Workflows'),
    component: AutomationsPage,
    exact: true,
    icon: 'arrow-progress',
    invalidateTimeline: true,
  },
};

paths.forEach((path, routeId) => {
  routes[routeId].path = path;
});

export default routes;
